export const EXTEND_BABY_LOAN_WITH = [
	{ label: "CSOK-kal", value: "CSOK" },
	{ label: "Lakáshitellel", value: "MORTGAGE" },
	{ label: "Személyi kölcsönnel", value: "PERSONAL_LOAN" },
];
